import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="max-w-lg mx-auto px-4 py-16 text-center">
      <p className="text-6xl font-extrabold text-primary mb-4">404</p>
      <h1 className="text-2xl font-extrabold text-navy mb-2">Page Not Found</h1>
      <p className="text-gray-400 mb-8">
        The page you're looking for doesn't exist or may have been moved.
        Let us help you find what you need.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link to="/" className="btn btn-primary">
          Go Home
        </Link>
        <Link to="/clinics" className="btn btn-outline">
          <MapPin className="w-4 h-4" />
          Find Clinics
        </Link>
      </div>
      <div className="mt-12 text-sm text-gray-400">
        <p>
          Medical emergency? Call{' '}
          <a href="tel:911" className="text-danger font-semibold hover:underline">911</a>
          {' '}or{' '}
          <a href="tel:919" className="text-danger font-semibold hover:underline">919</a>
        </p>
      </div>
    </div>
  );
}
